import { FuseLoadable } from "@fuse";
import EmpresaFinanceiroApp from "app/ERP/EmpresaFinanceiro/EmpresaFinanceiroApp";
import React from "react";

export const ERPAppConfig = {

    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: "/:organizacao/:empresa/empresapaciente",
            component: FuseLoadable({
                loader: () => import("./EmpresaPaciente/EmpresaPacienteApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresaimovel",
            component: FuseLoadable({
                loader: () => import("./EmpresaImovel/EmpresaImovelApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresacliente",
            component: FuseLoadable({
                loader: () => import("./EmpresaCliente/EmpresaClienteApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresaplanosaude",
            component: FuseLoadable({
                loader: () => import("./EmpresaPlanoSaude/EmpresaPlanoSaudeApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresafornecedor",
            component: FuseLoadable({
                loader: () => import("./EmpresaFornecedor/EmpresaFornecedorApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresaimobiliaria",
            component: FuseLoadable({
                loader: () => import("./EmpresaImobiliaria/EmpresaImobiliariaApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresacorretor",
            component: FuseLoadable({
                loader: () => import("./EmpresaCorretor/EmpresaCorretorApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresafuncionario",
            component: FuseLoadable({
                loader: () => import("./EmpresaFuncionario/EmpresaFuncionarioApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresaproduto",
            component: FuseLoadable({
                loader: () => import("./EmpresaProduto/EmpresaProdutoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresagrupoproduto",
            component: FuseLoadable({
                loader: () => import("./EmpresaGrupoProduto/EmpresaGrupoProdutoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresadeposito",
            component: FuseLoadable({
                loader: () => import("./EmpresaDeposito/EmpresaDepositoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresadepartamento",
            component: FuseLoadable({
                loader: () => import("./EmpresaDepartamento/EmpresaDepartamentoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresatag",
            component: FuseLoadable({
                loader: () => import("./EmpresaTag/EmpresaTagApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresasmarttext",
            component: FuseLoadable({
                loader: () => import("./EmpresaSmartText/EmpresaSmartTextApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresacategoria",
            component: FuseLoadable({
                loader: () => import("./EmpresaCategoria/EmpresaCategoriaApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresaconta",
            component: FuseLoadable({
                loader: () => import("./EmpresaConta/EmpresaContaApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresa-forma-pagamento",
            component: FuseLoadable({
                loader: () => import("./EmpresaFormaPagamento/EmpresaFormaPagamentoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresacentrocusto",
            component: FuseLoadable({
                loader: () => import("./EmpresaCentroCusto/EmpresaCentroCustoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresafinanceiro/caixaaberto",
            component: () => <EmpresaFinanceiroApp tipo={"caixaaberto"} />
        },
        {
            path: "/:organizacao/:empresa/empresafinanceiro/caixa",
            component: () => <EmpresaFinanceiroApp tipo={"caixa"} />
        },
        {
            path: "/:organizacao/:empresa/empresafinanceiro/apagar",
            component: () => <EmpresaFinanceiroApp tipo={"apagar"} />
        },
        {
            path: "/:organizacao/:empresa/empresafinanceiro/areceber",
            component: () => <EmpresaFinanceiroApp tipo={"areceber"} />
        },
        {
            path: "/:organizacao/:empresa/empresafinanceiro/contas",
            component: () => <EmpresaFinanceiroApp tipo={"contas"} />
        },
        {
            path: "/:organizacao/:empresa/empresafinanceiro/extrato",
            component: () => <EmpresaFinanceiroApp tipo={"extrato"} />
        },
        {
            path: "/:organizacao/:empresa/empresa-dre",
            component: FuseLoadable({
                loader: () => import("./EmpresaDRE/EmpresaDREApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresaestoque/:id",
            component: FuseLoadable({
                loader: () => import("./EmpresaEstoque/EmpresaEstoqueApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/all",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/MinhasTarefasApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/atendimentomedico",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/AtendimentoMedicoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/atendimento-barber",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/AtendimentoBarberApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/atendimento-beauty",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/AtendimentoBeautyApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/atendimento-crm",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/AtendimentoCrmApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/atendimento-odonto",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/AtendimentoOdontoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/minhastarefas/apontamentohoras",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/ApontamentoHorasApp")
            })
        },
        {
            path: "/minhastarefas/solicitacoes/:empresa",
            component: FuseLoadable({
                loader: () => import("../Workflow/MinhasTarefas/Apps/SolicitacoesApp")
            })
        },
        {
            path: "/:organizacao/:empresa/arquivo",
            component: FuseLoadable({
                loader: () => import("../GED/Arquivo/ArquivoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresapessoaprontuario",
            component: FuseLoadable({
                loader: () => import("./EmpresaPessoaProntuario/EmpresaPessoaProntuarioApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresalocal",
            component: FuseLoadable({
                loader: () => import("./EmpresaLocal/EmpresaLocalApp")
            })
        },
        {
            path: "/:organizacao/:empresa/agendamento/medico",
            component: FuseLoadable({
                loader: () => import("../CRM/Agendamento/Apps/MedicoApp")
            })
        },
        {
            path: "/:organizacao/:empresa/agendamento/imovel",
            component: FuseLoadable({
                loader: () => import("../CRM/Agendamento/Apps/ImovelApp")
            })
        },
        {
            path: "/:organizacao/:empresa/agendamento/barber",
            component: FuseLoadable({
                loader: () => import("../CRM/Agendamento/Apps/BarberApp")
            })
        },
        {
            path: "/:organizacao/:empresa/agendamento/crm",
            component: FuseLoadable({
                loader: () => import("../CRM/Agendamento/Apps/CrmApp")
            })
        },
        {
            path: "/:organizacao/:empresa/agendamento/beauty",
            component: FuseLoadable({
                loader: () => import("../CRM/Agendamento/Apps/BeautyApp")
            })
        },
        {
            path: "/:organizacao/:empresa/agendamento/odonto",
            component: FuseLoadable({
                loader: () => import("../CRM/Agendamento/Apps/OdontoApp")
            })
        },
        {
            path: "/home",
            component: FuseLoadable({
                loader: () => import("./EmpresaDashboards/EmpresaDashboardsApp")
            })
        },
        {
            path: "/:organizacao/:empresa/empresafaturamento",
            component: FuseLoadable({
                loader: () => import("./EmpresaFaturamento/EmpresaFaturamentoApp")
            })
        },
        {
            path: "/temp",
            component: () => <React.Fragment></React.Fragment>
        },
    ]
};
